// extracted by mini-css-extract-plugin
module.exports = {"connectButton":"button-module_connectButton_996bb","syncing":"button-module_syncing_af1de"};